import styled from 'styled-components';

export const VideoWrapper = styled.div`
  background-color: #ffffff;
  padding: 0px;
  margin: 0px;
`;
